export type { PropsMdmTable } from "./MdmTable";
export { MdmTable } from "./MdmTable";
